import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Printer, ArrowLeft, Award } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import api from "../lib/api";

const Logo = () => (
  <svg viewBox="0 0 48 48" width="72" height="72" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M4 30 L18 16 L18 24 L30 24 L30 16 L44 30 L44 34 L4 34 Z" fill="#3fae4a" />
    <rect x="14" y="30" width="20" height="8" rx="2" fill="#0a2447" />
    <circle cx="18" cy="40" r="3.4" fill="#0a2447" />
    <circle cx="30" cy="40" r="3.4" fill="#0a2447" />
  </svg>
);

const Certificate = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [progress, setProgress] = useState(null);

  useEffect(() => {
    if (!loading && !user) navigate("/training");
  }, [loading, user, navigate]);

  useEffect(() => {
    if (user) api.get("/course/progress").then((r) => setProgress(r.data)).catch(() => {});
  }, [user]);

  const today = new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });
  const name = user?.name || "Student";

  return (
    <div className="cert-page" data-testid="certificate-page">
      <div className="cert-toolbar">
        <Link to="/training" className="cert-back"><ArrowLeft size={16} /> Back to course</Link>
        <button className="btn btn-primary" onClick={() => window.print()} data-testid="cert-print"><Printer size={16} /> Print / Save PDF</button>
      </div>

      <div className="cert" data-testid="certificate">
        <div className="cert-inner">
          {progress && !progress.certified && <span className="cert-watermark" data-testid="cert-preview-watermark">PREVIEW</span>}
          <div className="cert-logo"><Logo /></div>
          <div className="cert-brand">FLYING FLEET DISPATCH LLC</div>
          <div className="cert-sub">Your Success Is Our Mission</div>
          <div className="cert-ribbon"><Award size={20} /> Certificate of Completion</div>
          <p className="cert-presented">This certifies that</p>
          <h1 className="cert-name">{name}</h1>
          <p className="cert-body">has successfully completed the</p>
          <h2 className="cert-course">Carrier Sourcing &amp; Dispatching Masterclass</h2>
          <p className="cert-desc">A 10-module program covering trucking foundations, business setup &amp; compliance, carrier sourcing, load evaluation, rate negotiation, dispatch operations, documents &amp; billing, marketing, and scaling.</p>
          <div className="cert-footer">
            <div className="cert-sign"><span className="cert-sig-line">Flying Fleet Dispatch LLC</span><span className="cert-sig-label">Authorized Signature</span></div>
            <div className="cert-seal"><Award size={30} /><span>Dispatch<br/>Academy</span></div>
            <div className="cert-sign"><span className="cert-sig-line">{today}</span><span className="cert-sig-label">Date of Completion</span></div>
          </div>
        </div>
      </div>

      {progress && !progress.certified && (
        <p className="cert-hint" data-testid="cert-incomplete-hint">Note: you've completed {progress.completed.length}/{progress.total} modules. Finish all 10 in the course to officially earn your certificate.</p>
      )}
    </div>
  );
};

export default Certificate;
